import { MeteringPoint } from './metering-point.model';
import { MeteringType } from '@enums';

export class MeteringPointGroup {
    id?: number;
    name?: string;
    meteringPoints?: MeteringPoint[] = [];
    meteringType?: MeteringType;
    selected?: boolean;

  public static MockOne(id = 1, name = 'MockGroup', meteringPoints = MeteringPoint.MockMany()) {
    return { id, name, meteringPoints: meteringPoints } as MeteringPointGroup;
  }

  public static MockMany() {
    return [MeteringPointGroup.MockOne(), MeteringPointGroup.MockOne(2)];
  }
}
